export const QUERY_META_ADS_STATUS = ["META_ADS_STATUS"];

export const CALLBACK_REASON_MESSAGES: Record<string, string> = {
  invalid_state: "OAuth state was invalid or expired. Please try again.",
  partner_not_found: "Could not match the partner from the callback.",
  short_lived_exchange_failed:
    "Failed to exchange the authorization code with Meta.",
  long_lived_exchange_failed: "Failed to obtain a long-lived access token.",
  list_pages_failed: "Failed to list your Facebook Pages.",
  fetch_me_failed: "Failed to read your Facebook account profile.",
  fetch_me_no_id:
    "Meta returned no user id for your account. Please reauthorize.",
  missing_params: "OAuth response was missing required parameters."
};

export const formatTokenExpiry = (iso: string | null): string => {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  const diffDays = Math.floor((then - Date.now()) / (24 * 60 * 60 * 1000));
  if (diffDays < 0) return "expired";
  if (diffDays === 0) return "today";
  if (diffDays === 1) return "tomorrow";
  return `in ${diffDays} days`;
};
